import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Subject, takeUntil } from 'rxjs';

import { FeatureToggleService, FeatureToggleType } from 'ish-core/feature-toggle.module';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';

import { b2bNavigationItems, b2cNavigationItems } from './account-navigation.items dias';

export interface NavigationItem {
  id: string;
  localizationKey: string;
  routerLink?: string;
  faIcon?: IconProp;
  isCollapsed?: boolean;
  feature?: FeatureToggleType;
  serverSetting?: string;
  permission?: string | string[];
  notRole?: string | string[];
  children?: NavigationItem[];
}

/**
 * The account navigation component displays the items of the account navigation menu. The navigation items are defined in the account-navigation.items.<theme>.ts or account-navigation.items.ts, respectively.
 */
@Component({
  selector: 'ish-account-navigation',
  templateUrl: './account-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountNavigationComponent implements OnDestroy {
  @Input() deviceType: DeviceType;

  /**
   * Manages the Account Navigation items.
   */
  navItems: NavigationItem[];
  applicationTypeClass: string;
  private destroy$ = new Subject<void>();

  activeClass = 'active';

  constructor(private router: Router, private featureToggleService: FeatureToggleService) {
    //If quick-order is enabled, consider it as a b2b site
    this.applicationTypeClass = this.featureToggleService.enabled('customQuickorder')
      ? 'b2b-account-nav'
      : 'b2c-account-nav';
    this.featureToggleService
      .enabled$('customQuickorder')
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.navItems = data ? b2bNavigationItems : b2cNavigationItems;
      });
  }

  activeChanged(active: boolean, activeItem: NavigationItem) {
    if (active && activeItem) {
      const parentItem = this.navItems.find(item => item.children?.find(subitem => subitem.id === activeItem?.id));
      if (parentItem) {
        parentItem.isCollapsed = false;
      }
    }
  }

  toggleCollapse(item: NavigationItem) {
    item.isCollapsed = !item.isCollapsed;
  }

  isSelected(item: NavigationItem): string {
    return item.routerLink === location.pathname ? 'selected' : undefined;
  }

  navigateTo(target: EventTarget) {
    if (target) {
      this.router.navigateByUrl((target as HTMLDataElement).value);
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
